import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import Login from "../Pages/LoginPage/LoginReg";
import UserPage from "../Pages/UserPage/UserPage"
import Add from "../Pages/Add/Add";
import All from "../Pages/UserPage/UserPageHelp/All"
import Sale from "../Pages/UserPage/UserPageHelp/Sale";
import Rent from "../Pages/UserPage/UserPageHelp/Rent";
import Delete from "../Pages/UserPage/UserPageHelp/Delete";
import SearchedData from "../Pages/UserPage/SearchedData";
import EstatePage from "../Pages/EstatePage/EstatePage";
import { useLocation } from "react-router-dom";
import {
  getAllRealEstate,
  getManagers,
  getBrokers,
  getDeleted
} from "../services/Real_estate";


export default function AppRouter() {
  const [allDeleted, setAllDeleted] = useState([])
  const location = useLocation();
  const [managers, setManagers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [data, setData] = useState([]);
  const [asr, setAsr]=useState([false,true,false, false])//all, sale, rent, deleted
  const [searchedData,  setSearchedData]=useState([])
  const [my, setMy] = useState(true)
  const [forRerander, setForRerander] = useState(false);
  const [estateOn, setEstateOn] = useState(false)
  const [district, setDistrict] = useState([]);
  const [district1, setDistrict1] = useState([]);
  const [district2, setDistrict2] = useState([]);

   useEffect(() => {
      getManagers().then(setManagers).catch(console.error);
      getBrokers().then(setBrokers).catch(console.error);
   }, []);
  useEffect(() => {
    getAllRealEstate()
      .then((res) => {
        console.log("DATA FROM API:", res);
        setData(res);
      })
      .catch(console.error);
  }, []);
 useEffect(() => {
   getDeleted()
     .then((res) => {
       console.log("Deleted DATA FROM API:", res);
       
       setAllDeleted(res);
     })
     .catch(console.error);
 }, []);



  useEffect(() => {
    if (forRerander) {
      getAllRealEstate().then(setData).catch(console.error);
      setForRerander(false);
    }
  }, [forRerander]);
  useEffect(() => {
    // Если путь не соответствует страницам типа "sale", "rent", "delete", "searched" — скрываем Estate
    const pathParts = location.pathname.split("/").filter(Boolean);
    const lastPart = pathParts[pathParts.length - 1];
    const isNumber = !isNaN(Number(lastPart));
    if (isNumber && Number(lastPart)<1000) {
      setEstateOn(false);
    }
  }, [location.pathname, setEstateOn]);


  return (
    <div>
      <Routes>
        <Route
          index
          element={
            <Login
              brokers={brokers}
              setUser={setBrokers}
              managers={managers}
              setManagers={setManagers}
            />
          }
        />
        <Route
          path="/:id"
          element={
            <UserPage
              brokers={brokers}
              managers={managers}
              setAsr={setAsr}
              setSearchedData={setSearchedData}
              estateOn={estateOn}
              my={my}
              setMy={setMy}
              district={district}
              district1={district1}
	      district2={district2}
              setDistrict1={setDistrict1}
              setDistrict={setDistrict}
	      setDistrict2={setDistrict2}
              asr={asr}
              data={data}
              allDeleted={allDeleted}
            />
          }
        >
          <Route
            index
            element={
              <Sale
                
                setAllDeleted={setAllDeleted}
                setSearchedData={setSearchedData}
                setEstateOn={setEstateOn}
                
                my={my}
              />
            }
          />
          <Route
            path="all"
            element={
              <All
                
                setAllDeleted={setAllDeleted}
                setSearchedData={setSearchedData}
                setEstateOn={setEstateOn}
                
                my={my}
              />
            }
          />
          <Route
            path="rent"
            element={
              <Rent
                setAllDeleted={setAllDeleted}
                setSearchedData={setSearchedData}
                
                setEstateOn={setEstateOn}
                
                my={my}
              />
            }
          />
          <Route
            path="delete"
            element={
              <Delete
                setEstateOn={setEstateOn}
                my={my}
                allDeleted={allDeleted}
              />
            }
          />
          <Route
            path=":estateId"
            element={
              <EstatePage
                setAllDeleted={setAllDeleted}
                setData={setData}
                setSearchedData={setSearchedData}
              />
            }
          />
          <Route
            path="searched"
            element={
              <SearchedData
                setAllDeleted={setAllDeleted}
                setEstateOn={setEstateOn}
                my={my}
                setData={setData}
                searchedData={searchedData}
                setSearchedData={setSearchedData}
              />
            }
          />
        </Route>
        <Route
          path="/:id/:estateId/add"
          element={
            <Add/>
          }
        />
        <Route
          path="/:id/add"
          element={
            <Add/>
          }
        />
      </Routes>
    </div>
  );
}
